<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/limonte-sweetalert2/8.11.8/sweetalert2.min.css"
    />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="flxRowTreatment">
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="headerTitle">
            <div class="seccionTitle">
              <b-icon
                class="iconuser mLeft"
                icon="layout-text-sidebar-reverse"
              ></b-icon>
              <div class="headerTxt mLeft">
                PTI Presuntivo (Diagnóstico tratamiento)
              </div>
            </div>
            <div class="alignIcon bold">BJ_menu_ptiHallazgo</div>
          </div>
          <b-form v-on:submit.prevent="sendData">
            <div class="modalBody">
              <!-- modal body -->
              <div class="flxRow">
                <div class="div100">
                  <diagnosisForm
                      :date="DiagnosticData.fechaAlta"
                      :clinicSelected="DiagnosticData.strNombreClinica"
                      :patComplete="DiagnosticData.nombrePaciente"
                      :patId="DiagnosticData.idPaciente"
                      :PatYears="DiagnosticData.edadPaciente"
                      :doctorSelected="DiagnosticData.nombreDoctor"
                      :enfermedad="DiagnosticData.enfermedadSistemica"
                      :candidato="DiagnosticData.candidatoOrtodoncia"
                      :observacion="DiagnosticData.observaciones"
                      :nivelPti="DiagnosticData.idNivelPti"
                      :idEstatus="DiagnosticData.intIdEstatusPTI"
                      @changeOrtodoncia="ChangeT($event)"
                  />
                </div>
              </div>
              <div
                  class="flxRow"
                  v-if="pacienteTomaHerramientas.mostrarTomaHerramientas"
              >
                <b-container>
                  <br />
                  <b-row style="width: 100%">
                    <b-col cols="2">
                      <label>Toma herramientas</label>
                    </b-col>

                    <b-col cols="10" align="left">
                      <div
                          v-for="trat in pacienteTomaHerramientas.tratamientosTomaHerramientas"
                          v-bind:key="trat.idTratamiento"
                      >
                        <b-form-checkbox
                            disabled
                            class="letraEstiloNegrita"
                            name="check-button"
                            checked="true"
                        >
                          {{ trat.descripcion }}
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </div>

              <div class="mt-2 col-md-12"></div>

              <!--Termina seccion header diagnostico-->
              <div class="tablasDientes">
                <b-tabs content-class="mt-3">
                  <b-tab
                      title="Niño"
                      v-if="
                    DiagnosticData.denticion == 1 ||
                    DiagnosticData.denticion == 3
                  "
                  >
                    <br />
                    <div class="btnLimpiarDiv">
                      <b-button
                          variant="info"
                          @click="cleanList('lstPlanTratamiento1', 'dientesNino')"
                      ><b-icon-trash animation="fade"></b-icon-trash> PTI
                        Presuntivo I</b-button
                      >
                    </div>
                    <br />
                    <div class="directionColum">
                      <div class="divFlexStart alignUnset">
                        <b-table-simple hover responsive class="paddingBottom">
                          <b-thead>
                            <b-tr class="columnas">
                              <b-th>OD</b-th>
                              <b-th>HALLAZGOS CLÍNICOS</b-th>
                              <b-th class="columnas">OD</b-th>
                              <b-th class="columnas">PTI Presuntivo I </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr v-for="diente in dientesNino" :key="diente.id">
                              <b-th>{{
                                  diente.idDiente == 73
                                      ? "SUPERNUMERARIO"
                                      : diente.numeroDiente
                                }}</b-th>
                              <b-td class="flxHallazgos">
                              <span class="selectsHallazgo">
                                <span
                                    v-for="(
                                    itemDos, index
                                  ) in diente.lstPadecimientos"
                                    :key="index"
                                >
                                  <p
                                      v-b-tooltip.hover
                                      :title="itemDos.descripcion"
                                      class="padecimientoCss"
                                  >
                                    {{ itemDos.descripcion.toUpperCase() }}
                                  </p>
                                  <!-- <b-form-input disabled id="input-with-list" v-model="itemDos.descripcion" v-b-tooltip.hover :title="itemDos.descripcion"></b-form-input> -->
                                  <br />
                                </span>
                              </span>
                              </b-td>
                              <!-- oddTratamiento -->
                              <b-td>
                                <b>{{
                                    diente.idDiente == 73
                                        ? "SUPERNUMERARIO"
                                        : diente.numeroDiente
                                  }}</b>
                                <b-dropdown
                                    size="sm"
                                    text="+"
                                    class="m-2"
                                    variant="primary"
                                    v-b-tooltip.hover
                                    title="Agregar más tratamientos"
                                    v-if="DiagnosticData.intIdEstatusPTI != 3"
                                >
                                  <b-dropdown-item-button
                                      class="dropDownCss"
                                      @click="
                                    addTreatment(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      'dientesNino',
                                      1
                                    )
                                  "
                                  >PTI Presuntivo I</b-dropdown-item-button
                                  >
                                </b-dropdown>
                              </b-td>
                              <b-td>
                                <div
                                    v-for="(
                                  itemDos, index
                                ) in diente.lstPlanTratamiento1"
                                    :key="index"
                                >
                                  <v-select
                                      label="nombre"
                                      :options=" dataTreatmentsMixto "
                                      v-model="itemDos.idTratamiento"
                                      :reduce="(variable) => variable.idTratamiento"
                                      @input="sendTreatment"
                                  ></v-select>
                                  <br />
                                </div>
                                <b-dropdown
                                    size="sm"
                                    text="Opciones de tratamientos"
                                    class="m-2"
                                    variant="primary"
                                    v-if="DiagnosticData.intIdEstatusPTI != 3"
                                >
                                  <b-dropdown-item-button
                                      v-if="diente.paquete1 != null"
                                      class="dropDownCss"
                                      v-b-tooltip.hover.right.v-primary
                                      :title="diente.paquete1Lista"
                                      @click="
                                    addPaquete(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      diente.paquete1,
                                      'dientesNino'
                                    )
                                  "
                                  >Paquete 1</b-dropdown-item-button
                                  >
                                  <b-dropdown-item-button
                                      v-if="diente.paquete2 != null"
                                      class="dropDownCss"
                                      v-b-tooltip.hover.right.v-primary
                                      :title="diente.paquete2Lista"
                                      @click="
                                    addPaquete(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      diente.paquete2,
                                      'dientesNino'
                                    )
                                  "
                                  >Paquete 2</b-dropdown-item-button
                                  >
                                  <b-dropdown-item-button
                                      v-if="diente.paquete3 != null"
                                      class="dropDownCss"
                                      v-b-tooltip.hover.right.v-primary
                                      :title="diente.paquete3Lista"
                                      @click="
                                    addPaquete(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      diente.paquete3,
                                      'dientesNino'
                                    )
                                  "
                                  >Paquete 3</b-dropdown-item-button
                                  >
                                </b-dropdown>
                                <b-button
                                    variant="outline-primary"
                                    class="btnTop"
                                    @click="
                                  limpiarDatosDiente(
                                    diente.numeroDiente,
                                    'lstPlanTratamiento1',
                                    'dientesNino'
                                  )
                                "
                                    v-if="DiagnosticData.intIdEstatusPTI != 3"
                                >
                                  <b-icon-trash animation="fade"></b-icon-trash>
                                  Limpiar</b-button
                                >
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </div>
                    <!-- plan de ortodoncia -->
                    <span v-if="DiagnosticData.candidatoOrtodoncia">
                    <!-- Nino -->
                    <span
                        v-if="
                        DiagnosticData.denticion == 1 ||
                        DiagnosticData.denticion == 3
                      "
                    >
                      <h3>Plan de Ortopedia Niño</h3>
                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX I</b-th>
                          </b-tr>
                        </b-thead>

                        <tr
                            v-for="(item, index) in titlesOrtodonciaNino"
                            :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                                type="number"
                                v-model="
                                ortodonciaNino['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                                min="0"
                                oninput="validity.valid||(value='');" onpaste="return false;"
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                                v-model="
                                ortodonciaNino['tratamientos1'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                                :options="optionsArcoBoca"
                                :disabled="
                                DiagnosticData.intIdEstatusPTI == 3 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 134 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                            ></b-form-select>

                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                                v-if="
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 134
                              "
                                label="nombre"
                                :options="dataTreatmentsOrtoOdonto"
                                :reduce="(val) => val.idTratamiento"
                                v-model="
                                ortodonciaNino['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                                :required="ortodonciaNino['tratamientos1'][index]['cantidad'] >= 1"
                                :class="selectClass(index)"
                                :state="selectClass(index)">
                            </v-select>
                             <b-form-invalid-feedback
                                 :state="(ortodonciaNino['tratamientos1'][index]['cantidad'] >= 0 && ortodonciaNino['tratamientos1'][index]['idTratamiento'] !== null && ortodonciaNino['tratamientos1'][index]['idTratamiento'] !== 0) ||
                                 ortodonciaNino['tratamientos1'][index]['cantidad'] <= 0">
                              Se debe seleccionar un tratamiento
                            </b-form-invalid-feedback>
                            <p
                                v-if="
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                                class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                        </tr>
                      </b-table-simple>

                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX I</b-th>
                          </b-tr>
                        </b-thead>
                        <tr
                            v-for="(item, index) in titlesOrtodonciaNinoDientes"
                            :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                                disabled
                                type="number"
                                v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                                min="0"
                                oninput="validity.valid||(value='');" onpaste="return false;"
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                                v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'lstDientes'
                                ]
                              "
                                taggable
                                multiple
                                :options="dientesNinoArray"
                                label="numeroDiente"
                                :reduce="(variable) => variable.idDiente"
                                @input="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaNinoDientes['tratamientos1'][index][
                                    'lstDientes'
                                  ].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                                v-if="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 136
                              "
                                label="nombre"
                                :options="dataTreatmentsExtracciones"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                                v-if="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 137
                              "
                                label="nombre"
                                :options="dataTreatmentsTopesResina"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                                v-if="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 138
                              "
                                label="nombre"
                                :options="dataTreatmentsTraccionCaninos"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                        </tr>
                      </b-table-simple>
                    </span>
                      <!-- Nino -->
                  </span>
                    <div v-else>
                      <h2>
                        <b-badge variant="info"
                        >No es candidato a Ortodoncia</b-badge
                        >
                      </h2>
                    </div>
                    <br />
                    <br />
                  </b-tab>
                  <b-tab
                      title="Adulto"
                      v-if="
                    DiagnosticData.denticion == 2 ||
                    DiagnosticData.denticion == 3
                  "
                  >
                    <br />
                    <div class="btnLimpiarDiv">
                      <b-button
                          variant="info"
                          @click="cleanList('lstPlanTratamiento1', 'dientesAdulto')"
                      ><b-icon-trash animation="fade"></b-icon-trash> PTI
                        Presuntivo I</b-button
                      >
                    </div>
                    <br />
                    <div class="directionColum">
                      <div class="divFlexStart alignUnset">
                        <b-table-simple hover responsive class="paddingBottom">
                          <b-thead>
                            <b-tr class="columnas">
                              <b-th>OD</b-th>
                              <b-th>HALLAZGOS CLÍNICOS</b-th>
                              <b-th class="columnas">OD</b-th>
                              <b-th class="columnas">PTI Presuntivo I </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                                v-for="diente in dientesAdulto"
                                :key="diente.id"
                            >
                              <b-th>{{
                                  diente.idDiente == 73
                                      ? "SUPERNUMERARIO"
                                      : diente.numeroDiente
                                }}</b-th>
                              <b-td class="flxHallazgos">
                              <span class="selectsHallazgo">
                                <span
                                    v-for="(
                                    itemDos, index
                                  ) in diente.lstPadecimientos"
                                    :key="index"
                                >
                                  <p
                                      v-b-tooltip.hover
                                      :title="itemDos.descripcion"
                                      class="padecimientoCss"
                                  >
                                    {{ itemDos.descripcion.toUpperCase() }}
                                  </p>
                                  <!-- <b-form-input disabled id="input-with-list" v-model="itemDos.descripcion" v-b-tooltip.hover :title="itemDos.descripcion"></b-form-input> -->
                                  <br />
                                </span>
                              </span>
                              </b-td>
                              <!-- oddTratamiento -->
                              <b-td>
                                <b>{{
                                    diente.idDiente == 73
                                        ? "SUPERNUMERARIO"
                                        : diente.numeroDiente
                                  }}</b>
                                <b-dropdown
                                    size="sm"
                                    text="+"
                                    class="m-2"
                                    variant="primary"
                                    v-b-tooltip.hover
                                    title="Agregar más tratamientos"
                                    v-if="DiagnosticData.intIdEstatusPTI != 3"
                                >
                                  <b-dropdown-item-button
                                      class="dropDownCss"
                                      @click="
                                    addTreatment(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      'dientesAdulto',
                                      1
                                    )
                                  "
                                  >PTI Presuntivo I</b-dropdown-item-button
                                  >
                                  <b-dropdown-item-button
                                      class="dropDownCss"
                                      @click="
                                    addTreatment(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento2',
                                      'dientesAdulto',
                                      2
                                    )
                                  "
                                  >PTI Presuntivo II</b-dropdown-item-button
                                  >
                                  <b-dropdown-item-button
                                      class="dropDownCss"
                                      @click="
                                    addTreatment(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento3',
                                      'dientesAdulto',
                                      3
                                    )
                                  "
                                  >PTI Presuntivo III</b-dropdown-item-button
                                  >
                                </b-dropdown>
                              </b-td>
                              <b-td>
                                <div
                                    v-for="(
                                  itemDos, index
                                ) in diente.lstPlanTratamiento1"
                                    :key="index"
                                >
<!--                                  AQUI ESTA PTI Presuntivo I tabla 1-->
                                  <v-select
                                      label="nombre"
                                      :options="
                                    DiagnosticData.denticion == 3
                                      ? dataTreatmentsMixto
                                      : dataTreatments
                                  "
                                      v-model="itemDos.idTratamiento"
                                      :reduce="(variable) => variable.idTratamiento"


                                      @input="sendTreatment"
                                  ></v-select>
                                  <br />
                                </div>
                                <b-dropdown
                                    size="sm"
                                    text="Opciones de tratamientos"
                                    class="m-2"
                                    variant="primary"
                                    v-if="DiagnosticData.intIdEstatusPTI != 3"
                                >
                                  <b-dropdown-item-button
                                      v-if="diente.paquete1 != null"
                                      class="dropDownCss"
                                      v-b-tooltip.hover.right.v-primary
                                      :title="diente.paquete1Lista"
                                      @click="
                                    addPaquete(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      diente.paquete1,
                                      'dientesAdulto'
                                    )
                                  "
                                  >Paquete 1</b-dropdown-item-button
                                  >
                                  <b-dropdown-item-button
                                      v-if="diente.paquete2 != null"
                                      class="dropDownCss"
                                      v-b-tooltip.hover.right.v-primary
                                      :title="diente.paquete2Lista"
                                      @click="
                                    addPaquete(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      diente.paquete2,
                                      'dientesAdulto'
                                    )
                                  "
                                  >Paquete 2</b-dropdown-item-button
                                  >
                                  <b-dropdown-item-button
                                      v-if="diente.paquete3 != null"
                                      class="dropDownCss"
                                      v-b-tooltip.hover.right.v-primary
                                      :title="diente.paquete3Lista"
                                      @click="
                                    addPaquete(
                                      diente.numeroDiente,
                                      'lstPlanTratamiento1',
                                      diente.paquete3,
                                      'dientesAdulto'
                                    )
                                  "
                                  >Paquete 3</b-dropdown-item-button
                                  >
                                </b-dropdown>
                                <b-button
                                    variant="outline-primary"
                                    class="btnTop"
                                    @click="
                                  limpiarDatosDiente(
                                    diente.numeroDiente,
                                    'lstPlanTratamiento1',
                                    'dientesAdulto'
                                  )
                                "
                                    v-if="DiagnosticData.intIdEstatusPTI != 3"
                                >
                                  <b-icon-trash animation="fade"></b-icon-trash>
                                  Limpiar</b-button
                                >
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </div>

                    <!-- plan de ortodoncia -->
                    <span v-if="DiagnosticData.candidatoOrtodoncia">
                    <!-- Adulto -->
                    <span
                        v-if="
                        DiagnosticData.denticion == 2 ||
                        DiagnosticData.denticion == 3
                      "
                    >
                      <h3>Plan de Ortodoncia Adulto</h3>
                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX I</b-th>
                          </b-tr>
                        </b-thead>
                        <tr
                            v-for="(item, index) in titlesOrtodonciaAdulto"
                            :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                                type="number"
                                v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                                min="0"
                                oninput="validity.valid||(value='');" onpaste="return false;"
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                                :disabled="
                                DiagnosticData.intIdEstatusPTI == 3 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 121 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                                v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                                :options="optionsArcoBoca"
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                                v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 121
                              "
                                label="nombre"
                                :options="dataTreatmentsOrtoOdontoFiltro"
                                :filterable="false"
                                @search="filtroOrtoOdonto"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                                :class="selectClassAdulto(index)"
                                :state="selectClassAdulto(index)"
                            ></v-select>
                            <!-- Otra opcion -->
                            <v-select
                                v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 109 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 110 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 171 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 172 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 173
                              "
                                label="nombre"
                                :options="dataTreatmentsOrtoFiltro"
                                :filterable="false"
                                @search="filtroOrto"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                                :class="selectClassAdulto(index)"
                                :state="selectClassAdulto(index)"
                            ></v-select>

                            <!-- Otra opcion -->
                            <v-select
                                v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 111 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 112
                              "
                                label="nombre"
                                :options="dataTreatmentsRetenedoresFitro"
                                :filterable="false"
                                @search="filtroRetenedores"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                                :required="ortodonciaAdulto['tratamientos1'][index]['cantidad'] >= 1"
                                :class="selectClassAdulto(index)"
                                :state="selectClassAdulto(index)"
                            ></v-select>
                            <b-form-invalid-feedback
                                :state="(ortodonciaAdulto['tratamientos1'][index]['cantidad'] >= 0 && ortodonciaAdulto['tratamientos1'][index]['idTratamiento'] !== null && ortodonciaAdulto['tratamientos1'][index]['idTratamiento'] !== 0) ||
                                 ortodonciaAdulto['tratamientos1'][index]['cantidad'] <= 0">
                              Se debe seleccionar un tratamiento
                            </b-form-invalid-feedback>
                            <p
                                v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                                class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                        </tr>
                      </b-table-simple>

                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX I</b-th>
                          </b-tr>
                        </b-thead>
                        <tr
                            v-for="(item, index) in titlesOrtodonciaAdultoDientes"
                            :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                                disabled
                                type="number"
                                v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                                min="0"
                                oninput="validity.valid||(value='');" onpaste="return false;"
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                                v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'lstDientes'
                                ]
                              "
                                taggable
                                multiple
                                :options="dientesAdultoArray"
                                label="numeroDiente"
                                :reduce="(variable) => variable.idDiente"
                                @input="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaAdultoDientes['tratamientos1'][
                                    index
                                  ]['lstDientes'].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                                v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 128
                              "
                                label="nombre"
                                :options="dataTreatmentsExtraccionesFiltro"
                                :filterable="false"
                                @search="filtroExtracciones"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                                v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 115
                              "
                                label="nombre"
                                :options="dataTreatmentsMiniImplantesFiltro"
                                :filterable="false"
                                @search="filtroMiniImplantes"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                                v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 116
                              "
                                label="nombre"
                                :options="dataTreatmentsTopesResinaFitro"
                                :filterable="false"
                                @search="filtroTopesResina"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                                v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 117
                              "
                                label="nombre"
                                :options="dataTreatmentsTraccionCaninosFiltro"
                                :filterable="false"
                                @search="filtroTraccionCaninos"
                                :reduce="(treatment) => treatment.idTratamiento"
                                v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                        </tr>
                      </b-table-simple>
                    </span>
                  </span>
                    <div v-else>
                      <h2>
                        <b-badge variant="info"
                        >No es candidato a Ortodoncia</b-badge
                        >
                      </h2>
                    </div>
                    <br />
                    <br />
                  </b-tab>
                </b-tabs>
              </div>

              <div class="pdxArcada">
                <!-- Padecimientos por arcada -->

                <h2 class="pdxArcadaPadding">
                  <b-badge class="colorPrincipal"
                  >Padecimientos por arcada</b-badge
                  >
                </h2>

                <strong class="colorTxt pdxArcadaPadding"> Superior </strong>

                <br />
                <br />

                <!-- Superior -->
                <b-table-simple hover responsive class="paddingBottom">
                  <b-thead>
                    <b-tr class="columnas">
                      <b-th>HALLAZGOS CLÍNICOS</b-th>
                      <b-th class="columnas">PTI Presuntivo I </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                        v-for="(padecimiento, indexPdx) in PdxSuperior"
                        :key="indexPdx"
                    >
                      <b-td class="flxHallazgos">
                      <span class="selectsHallazgo">
                        <span
                            v-for="(
                            itemDos, index
                          ) in padecimiento.lstPadecimientos"
                            :key="index"
                        >
                          <p
                              v-b-tooltip.hover
                              :title="itemDos.descripcion"
                              class="padecimientoCss"
                          >
                            {{ itemDos.descripcion.toUpperCase() }}
                          </p>
                          <br />
                        </span>
                      </span>
                      </b-td>
                      <!-- oddTratamiento -->
                      <b-td>
                        <div
                            v-for="(
                          itemDos, index
                        ) in padecimiento.lstPlanTratamiento1"
                            :key="index"
                        >
                          <v-select
                              label="nombre"
                              :options="dataTreatmentsMixtoFiltro"
                              :filterable="false"
                              @search="filtroTreatmentsMixto"
                              v-model="itemDos.idTratamiento"
                              :reduce="(variable) => variable.idTratamiento"
                              @input="sendTreatment"
                          ></v-select>
                          <br />
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <div class="paddingPadecimientosTabla"></div>
                </b-table-simple>
                <!-- Superior   -->

                <strong class="colorTxt pdxArcadaPadding"> Inferior </strong>

                <!-- inferior -->
                <b-table-simple hover responsive class="paddingBottom">
                  <b-thead>
                    <b-tr class="columnas">
                      <b-th>HALLAZGOS CLÍNICOS</b-th>
                      <b-th class="columnas">PTI Presuntivo I </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                        v-for="(padecimiento, indexPdx) in PdxInferior"
                        :key="indexPdx"
                    >
                      <b-td class="flxHallazgos">
                      <span class="selectsHallazgo">
                        <span
                            v-for="(
                            itemDos, index
                          ) in padecimiento.lstPadecimientos"
                            :key="index"
                        >
                          <p
                              v-b-tooltip.hover
                              :title="itemDos.descripcion"
                              class="padecimientoCss"
                          >
                            {{ itemDos.descripcion.toUpperCase() }}
                          </p>
                          <br />
                        </span>
                      </span>
                      </b-td>
                      <!-- oddTratamiento -->
                      <b-td>
                        <div
                            v-for="(
                          itemDos, index
                        ) in padecimiento.lstPlanTratamiento1"
                            :key="index"
                        >
                          <v-select
                              label="nombre"
                              :options="dataTreatmentsMixtoFiltro"
                              :filterable="false"
                              @search="filtroTreatmentsMixto"
                              v-model="itemDos.idTratamiento"
                              :reduce="(variable) => variable.idTratamiento"
                              @input="sendTreatment"
                          ></v-select>
                          <br />
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <div class="paddingPadecimientosTabla"></div>
                </b-table-simple>
                <!-- inferior -->

                <br />
                <br />

                <h2 class="pdxArcadaPadding">
                  <b-badge class="colorPrincipal"
                  >Padecimientos por toda la boca </b-badge
                  >
                </h2>
                <br />
                <!-- Padecimientos por arcada -->
                <!-- inferior -->
                <b-table-simple hover responsive class="paddingBottom">
                  <b-thead>
                    <b-tr class="columnas">
                      <b-th>HALLAZGOS CLÍNICOS</b-th>
                      <b-th class="columnas">PTI Presuntivo I </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                        v-for="(padecimiento, indexPdx) in PdxBocaCompleta"
                        :key="indexPdx"
                    >
                      <b-td class="flxHallazgos">
                      <span class="selectsHallazgo">
                        <span
                            v-for="(
                            itemDos, index
                          ) in padecimiento.lstPadecimientos"
                            :key="index"
                        >
                          <p
                              v-b-tooltip.hover
                              :title="itemDos.descripcion"
                              class="padecimientoCss"
                          >
                            {{ itemDos.descripcion.toUpperCase() }}
                          </p>
                          <br />
                        </span>
                      </span>
                      </b-td>
                      <!-- oddTratamiento -->
                      <b-td>
                        <div
                            v-for="(
                          itemDos, index
                        ) in padecimiento.lstPlanTratamiento1"
                            :key="index"
                        >
                          <v-select
                              label="nombre"
                              :options="dataTreatmentsMixtoFiltro"
                              :filterable="false"
                              @search="filtroTreatmentsMixto"
                              v-model="itemDos.idTratamiento"
                              :reduce="(variable) => variable.idTratamiento"
                              @input="sendTreatment"
                          ></v-select>
                          <br />
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <div class="paddingPadecimientosTabla"></div>
                </b-table-simple>
                <!-- inferior -->
              </div>

              <div
                  class="divFlexStart"
                  v-if="
                DiagnosticData.denticion == 2 || DiagnosticData.denticion == 3
              "
              >
                <table class="divItemHallazgos">
                  <!-- Ultima parte -->
                  <tr class="ultimaParte">
                    <td class="bold divItemCuatro txtTables">
                      PERIODONTITIS SUPERIOR
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          value="1"
                          class="divItemUno"
                          v-model="DiagnosticData.ipbS1"
                          name="check-button"
                          switch
                          disabled
                      >Cuadrante I</b-form-checkbox
                      >
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          value="1"
                          class="divItemUno"
                          v-model="DiagnosticData.ipbS2"
                          name="check-button"
                          switch
                          disabled
                      >Cuadrante II</b-form-checkbox
                      >
                    </td>
                  </tr>
                  <tr class="ultimaParte">
                    <td class="bold divItemCuatro txtTables">
                      PERIODONTITIS INFERIOR
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          value="1"
                          class="divItemUno"
                          v-model="DiagnosticData.ipbI1"
                          name="check-button"
                          switch
                          disabled
                      >Cuadrante III</b-form-checkbox
                      >
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          value="1"
                          class="divItemUno"
                          v-model="DiagnosticData.ipbI2"
                          name="check-button"
                          switch
                          disabled
                      >Cuadrante IV</b-form-checkbox
                      >
                    </td>
                  </tr>
                </table>

                <table class="divItemTratamientos">
                  <tr class="ultimaParte">
                    <td class="bold divItemTres txtTables">
                      RASPADO Y ALISADO RADICULARES CERRADOS SUPERIOR
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          class="divItemUno"
                          name="check-button1"
                          id="check-button1"
                          switch
                          v-model="DiagnosticData.raspadoSuperior1"
                          @change="check"
                      >Cuadrante I</b-form-checkbox
                      >
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          class="divItemUno"
                          name="check-button2"
                          id="check-button2"
                          switch
                          v-model="DiagnosticData.raspadoSuperior2"
                          @change="check"
                      >Cuadrante II</b-form-checkbox
                      >
                    </td>
                  </tr>
                  <tr class="ultimaParte">
                    <td class="divItemTres bold txtTables">
                      RASPADO Y ALISADO RADICULARES CERRADOS INFERIOR
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          class="divItemUno"
                          name="check-button3"
                          id="check-button3"
                          switch
                          v-model="DiagnosticData.raspadoInferior1"
                          @change="check"
                      >Cuadrante III</b-form-checkbox
                      >
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          class="divItemUno"
                          name="check-button4"
                          id="check-button4"
                          switch
                          v-model="DiagnosticData.raspadoInferior2"
                          @change="check"
                      >Cuadrante IV</b-form-checkbox
                      >
                    </td>
                  </tr>
                  <tr class="ultimaPartePerio">
                    <td class="divItemTres bold txtTables">
                      TERAPIA DE MANTENIMIENTO PERIODONTAL
                    </td>
                    <td class="divItemTres">
                      <b-form-checkbox
                          class="divItemUno"
                          v-model="terapia"
                          name="check-button"
                          switch
                          disabled
                      ></b-form-checkbox>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="tablaRutas">
                <div
                    class="tablesDisplayFlx"
                    v-if="DiagnosticData.lstRutaTratamientoEspecialidad.length != 0"
                >
                  <b-table-simple class="mginTop15 divItemUno" hover responsive>
                    <b-thead>
                      <b-tr class="columnas">
                        <b-th>RUTA</b-th>
                        <b-th>PTI Presuntivo I</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                          v-for="(
                        item, index
                      ) in DiagnosticData.lstRutaTratamientoEspecialidad"
                          :key="item.idFront"
                      >
                        <b-td
                            class="columnas colorSubtitle divOrden"
                            v-if="item.intgerOrden != null"
                        >
                          <div>{{ item.intgerOrden }}</div>
                          <div
                              class="styleButtons"
                              v-if="DiagnosticData.intIdEstatusPTI != 3"
                          >
                            <b-icon-arrow-up
                                class="iconBtn"
                                @click="move(index, index - 1)"
                            ></b-icon-arrow-up>
                            <b-icon-arrow-down
                                class="iconBtn"
                                @click="move(index, index + 1)"
                            ></b-icon-arrow-down>
                          </div>
                        </b-td>
                        <b-td v-if="item.intgerOrden != null">
                          <select class="divItemUno" disabled>
                            <option value selected hidden>
                              {{ item.nombreEspecialidad1 }}
                            </option>
                          </select>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
                <br />
              </div>
              <br />
              <br />
              <!-- Guardar -->
              <textarea
                  name="textarea"
                  rows="5"
                  cols="130"
                  v-model.lazy="DiagnosticData.observacionesDiagnostico"
                  placeholder="Observaciones centro de diagnostico"
              ></textarea>

              <b-form-group label="Posible rechazo">
                <b-form-radio-group
                    v-model="DiagnosticData.posibleReplica"
                    :options="optionsReplica"
                    name="radio-replica"
                ></b-form-radio-group>
              </b-form-group>

              <b-button
                  class="btnSave"
                  :disabled="banderaBtn == true"
                  type="submit"
                  v-if="$localStorageService.can('DX_05_guardar_pti_presun')"
              >GUARDAR</b-button
              >

              <br />
              <br />
<!--              <table>-->
<!--                <template v-for="diente in DiagnosticData.listaDientes" >-->
<!--                  <tr v-for="(pad, idx) in diente.lstPadecimientos" :key="idx">-->
<!--                    <th style="width: 30%" >-->
<!--                      ({{diente.idDiente}}){{diente.numeroDiente}}-->
<!--                    </th>-->
<!--                    <th style="width: 70%" rowspan="1">-->
<!--                      <div >-->
<!--                        {{pad}}-->
<!--                      </div>-->
<!--                    </th>-->
<!--                  </tr>-->
<!--                </template>-->
<!--              </table>-->

              <!--seccion tabla-->
            </div>
          </b-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};
//components
import Header from "../components/Header.vue";

import diagnosisForm from "@/components/diagnosis/diagnosisForm.vue";

import moment from "moment";

import _ from "lodash";



export default {
  name: "PtiPresuntivoSinSDI",
  components: {
    Header,
    diagnosisForm,
  },
  props: {
    msg: String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idClinica: null,
    dataTreatmentsMixto: [],
    dataTreatmentsMixtoFiltro: [],
    loadingDientesAdulto: true,
    loadingDientesNino: true,
    trtsCasosEsp: [],
    espGeneral: false,
    terapia: false,
    banderaBtn: false,
    DiagnosticData: {
      bruxismo: false,
      candidatoOrtodoncia: false,
      enfermedadSistemica: "",
      edadPaciente: 0,
      fechaAlta: "",
      folio: null,
      idClinica: null,
      idCompania: null,
      idEmpleado: null,
      idMordida: null,
      idNivelPti: 0,
      idPaciente: 0,
      idPti: "",
      idRiesgoMonto: null,
      idRiesgoidTratamiento: null,
      idUsuarioLogueado: null,
      intIdEstatusPTI: null,
      ipbI1: null,
      ipbI2: null,
      ipbS1: null,
      ipbS2: null,
      listaDientes: [],
      lstRutaTratamientoEspecialidad: [],
      nombreDoctor: "",
      nombrePaciente: "",
      observaciones: "",
      placaSarro: Boolean,
      raspadoInferior1: Boolean,
      raspadoInferior2: Boolean,
      raspadoSuperior1: Boolean,
      raspadoSuperior2: Boolean,
      registroActivo: Boolean,
      strNombreClinica: "",
      observacionesDiagnostico: null,
      interconsulta: null,
      posibleReplica: false,
      intIdTipoSolicitudPTI: null,
    },
    optionsReplica: [
      {
        text: "No",
        value: null,
      },
      {
        text: "Si",
        value: true,
      },
    ],
    dataTreatments: [],
    dataTreatmentsFiltro: [],
    dientesNino: [],
    dientesAdulto: [],
    optionsPlaca: [
      {
        text: "Limpieza",
        value: 1,
        disabled: true,
      },
      {
        text: "Limpieza con barniz de flúor",
        value: 2,
        disabled: true,
      },
      {
        text: "Eliminación de sarro e higiene de encías",
        value: 3,
        disabled: true,
      },
    ],
    optionsBruxismo: [
      {
        text: "Guarda oclusal",
        value: 1,
      },
      {
        text: "Guarda oclusal confeccionado en laboratorio",
        value: 2,
      },
    ],
    loading: false,
    dataTreatmentsNino: [],
    dataSendTrts: [],
    // !ADULTO
    titlesOrtodonciaAdulto: [
      "ESTUDIOS",
      "BRACKETS/ALINEADORES",
      "CITAS",
      "CITAS",
      "CITAS",
      "CITAS",
      "RET SUP",
      "RET INF",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
    ],
    ortodonciaAdulto: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    titlesOrtodonciaAdultoDientes: [
      "EXTRACCIONES",
      "MINI IMPLANTES",
      "TOPES DE RESINA",
      "TRACCIÓN DE CANINOS",
    ],
    ortodonciaAdultoDientes: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    // !NINO
    titlesOrtodonciaNino: [
      "ESTUDIOS",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
    ],
    ortodonciaNino: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    titlesOrtodonciaNinoDientes: [
      "EXTRACCIONES",
      "TOPES DE RESINA",
      "TRACCIÓN DE CANINOS",
    ],
    ortodonciaNinoDientes: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    // !GENERALES ORTODONCIA
    optionsArcoBoca: [
      {
        value: 0,
        text: "Selecciona una opción",
      },
      {
        value: 57,
        text: "Superior",
      },
      {
        value: 58,
        text: "Inferior",
      },
      {
        value: 59,
        text: "Boca Completa",
      },
    ],
    dataTreatmentsOrtoOdonto: [],
    dataTreatmentsOrtoOdontoFiltro: [],
    dataTreatmentsOrto: [],
    dataTreatmentsOrtoFiltro: [],
    // POR ID
    dataTreatmentsRetenedores: [],
    dataTreatmentsRetenedoresFitro: [],
    dataTreatmentsCitaAjuste: [],
    dataTreatmentsExtracciones: [],
    dataTreatmentsExtraccionesFiltro: [],
    dataTreatmentsMiniImplantes: [],
    dataTreatmentsMiniImplantesFiltro: [],
    dataTreatmentsTopesResina: [],
    dataTreatmentsTopesResinaFitro: [],
    dataTreatmentsTraccionCaninos: [],
    dataTreatmentsTraccionCaninosFiltro: [],
    dientesAdultoArray: [],
    dientesAdultoArrayFiltro: [],
    dientesNinoArray: [],
    fechaAltaUtc: null,
    pacienteTomaHerramientas: {
      mostrarTomaHerramientas: false,
      sesionTomaHerramientas: false,
      tratamientosTomaHerramientas: [],
    },
    PdxSuperior: [],
    PdxInferior: [],
    PdxBocaCompleta: [],
  }),

  beforeMount() {
    this.loading = true;
    this.getDientes("dientesAdulto");
    this.getDientes("dientesNino");

    // ! GET ORTODONCIA
    this.getOrtodoncia();

    this.$http
      .get(
        this.$api +
          "pti/obtenerTomaHerramientasPTI?idPti=" +
          this.$route.params.id
      )
      .then((response) => {
        this.pacienteTomaHerramientas = response.data.data;
      });
  },
  mounted() {
    // ! AQUI CREAMOS EL ARRAY FORZAMOS QUE HASTA QUE TRAIGA LOS DATOS DE LOS TRATAMIENTOS
    this.createArray("tratamientos1");
    this.createArray("tratamientos2");
    this.createArray("tratamientos3");
/*
    this.constuirPdx(
      57,
      [
        { id: 165, nombre: "ANODONCIA PARCIAL O TOTAL" },
        { id: 162, nombre: "FRENILLO CORTO" },
        { id: 49, nombre: "HIPERPLASIA GINGIVAL" },
        { id: 10, nombre: "BRUXISMO" },
      ],
      "PdxSuperior"
    );
    this.constuirPdx(
      58,
      [
        { id: 165, nombre: "ANODONCIA PARCIAL O TOTAL" },
        { id: 162, nombre: "FRENILLO CORTO" },
        { id: 49, nombre: "HIPERPLASIA GINGIVAL" },
      ],
      "PdxInferior"
    );
    this.constuirPdx(
      59,
      [
        { id: 73, nombre: "PIGMENTACIÓN DENTAL" },
      ],
      "PdxBocaCompleta"
    );*/
  },
  methods: {

    filtroTreatmentsMixto(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
        this.dataTreatmentsMixtoFiltro = this.dataTreatmentsMixto.filter(em => {
          return em.nombre.toLowerCase().includes(seach.toLowerCase())}
        )

      loading(false)
    },
    filtroTraccionCaninos(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsTraccionCaninosFiltro = this.dataTreatmentsTraccionCaninos.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroTopesResina(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsTopesResinaFiltro = this.dataTreatmentsTopesResina.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroMiniImplantes(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsMiniImplantesFiltro = this.dataTreatmentsMiniImplantes.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroExtracciones(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsExtraccionesFiltro = this.dataTreatmentsExtracciones.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroAdultoArray(busqueda, loading){//para lod dientes revisarlo bien ya que es multiple
      loading(true)
      let seach = busqueda.trim()
      this.dientesAdultoArrayFiltro = this.dientesAdultoArray.filter(em => {
        return em.numeroDiente.toString().toLowerCase().trim().includes(seach.toString().toLowerCase())
      })
      loading(false)
    },
    filtroRetenedores(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsRetenedoresFitro = this.dataTreatmentsRetenedores.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOrto(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsOrtoFiltro = this.dataTreatmentsOrto.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOrtoOdonto(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.dataTreatmentsOrtoOdontoFiltro = this.dataTreatmentsOrtoOdonto.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroTratamientos(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      if(this.DiagnosticData.denticion == 3){
          this.dataTreatmentsMixtoFiltro = this.dataTreatmentsMixto.filter(em => {
           return em.nombre.toLowerCase().includes(seach.toLowerCase())}
           )
        }else{
            this.dataTreatmentsFiltro = this.dataTreatments.filter(em => {
              return em.nombre.toLowerCase().includes(seach.toLowerCase())}
            )
        }

      loading(false)
    },
    selectClass(index) {
      const state = (this.ortodonciaNino['tratamientos1'][index]['cantidad'] >= 0 && this.ortodonciaNino['tratamientos1'][index]['idTratamiento'] !== null && this.ortodonciaNino['tratamientos1'][index]['idTratamiento'] !== 0) ||
          this.ortodonciaNino['tratamientos1'][index]['cantidad'] <= 0
      if (state) {
        return 'border rounded-lg border-success'
      } else {
        return 'border rounded-lg border-danger'
      }
    },
    selectClassAdulto(index) {
      const state = (this.ortodonciaAdulto['tratamientos1'][index]['cantidad'] >= 0 && this.ortodonciaAdulto['tratamientos1'][index]['idTratamiento'] !== null && this.ortodonciaAdulto['tratamientos1'][index]['idTratamiento'] !== 0) ||
          this.ortodonciaAdulto['tratamientos1'][index]['cantidad'] <= 0
      if (state) {
        return 'border rounded-lg border-success'
      }
      else {
        return 'border rounded-lg border-danger'
      }
    },
    ChangeT(data) {
      this.DiagnosticData.candidatoOrtodoncia = data;
    },
    getOrtodoncia() {
      const params = {
        idPti: this.$route.params.id, 
        perfilPaciente: false
      }
      this.$http
        .post(
          this.$api +
            "ptipresuntivo/obtener/planes/ortodoncia", params)
        .then((response) => {
          response.data.data.tratamientos1.forEach((element) => {
            this.ortodonciaAdulto.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaAdultoDientes.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA ADULTO
            this.ortodonciaNino.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaNinoDientes.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
          });
          //el dos

          response.data.data.tratamientos2.forEach((element) => {
            this.ortodonciaAdulto.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaAdultoDientes.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA ADULTO
            this.ortodonciaNino.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaNinoDientes.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
          });
          // el tres
          response.data.data.tratamientos3.forEach((element) => {
            // ! TERMINA Nino
            this.ortodonciaAdulto.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaAdultoDientes.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA ADULTO
            this.ortodonciaNino.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaNinoDientes.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA Nino
          });

          this.$forceUpdate();
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener la seccion de ortodoncia",
          });
          console.error(error);
        });
    },
    saveOrtodoncia() {
      var datos = {
        idEmpleado: this.DiagnosticData.idEmpleado,
        idPti: this.DiagnosticData.idPti,
        tratamientos1: this.ortodonciaAdulto["tratamientos1"].concat(
          this.ortodonciaAdultoDientes["tratamientos1"],
          this.ortodonciaNino["tratamientos1"],
          this.ortodonciaNinoDientes["tratamientos1"]
        ),
        tratamientos2: this.ortodonciaAdulto["tratamientos2"].concat(
          this.ortodonciaAdultoDientes["tratamientos2"],
          this.ortodonciaNino["tratamientos2"],
          this.ortodonciaNinoDientes["tratamientos2"]
        ),
        tratamientos3: this.ortodonciaAdulto["tratamientos3"].concat(
          this.ortodonciaAdultoDientes["tratamientos3"],
          this.ortodonciaNino["tratamientos3"],
          this.ortodonciaNinoDientes["tratamientos3"]
        ),
      };

      datos.tratamientos1 = datos.tratamientos1.filter(
        (item) => item.cantidad != 0 && item.idTratamiento != null
      );

      datos.tratamientos2 = datos.tratamientos2.filter(
        (item) => item.cantidad != 0 && item.idTratamiento != null
      );

      datos.tratamientos3 = datos.tratamientos3.filter(
        (item) => item.cantidad != 0 && item.idTratamiento != null
      );

      if (Array.isArray(datos.tratamientos1)) {
        datos.tratamientos1.forEach((element) => {
          element.cantidad = parseInt(element.cantidad);
        });
      }

      if (Array.isArray(datos.tratamientos2)) {
        datos.tratamientos2.forEach((element) => {
          element.cantidad = parseInt(element.cantidad);
        });
      }

      if (Array.isArray(datos.tratamientos3)) {
        datos.tratamientos3.forEach((element) => {
          element.cantidad = parseInt(element.cantidad);
        });
      }

      this.$http
        .put(
          this.$api +
            "ptipresuntivo/guardar/planes/ortodoncia?idUsuarioLogueado=" +
            this.$localStorageService.getIdUsuario() +
            "&idClinica=" +
            this.$localStorageService.getIdClinica() +
            "&idPaciente=" +
            this.$route.params.id +
            "&crearSolicitudBandeja=" + true
            ,
          datos
        )
        .then(() => {
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          location.reload();
        });
    },
    createArray(treatment) {
      this.ortodonciaAdulto[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 59,
          idPadecimento: 118,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 109,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 110,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 171,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 172,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 173,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 111,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 112,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 113,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 120,
          idTratamiento: 49,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 121,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 122,
          idTratamiento: 49,
          lstDientes: [],
        },
      ];

      this.ortodonciaAdultoDientes[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 128,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 115,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 116,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 117,
          idTratamiento: 0,
          lstDientes: [],
        },
      ];

      this.ortodonciaNino[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 59,
          idPadecimento: 131,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 132,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 133,
          idTratamiento: 49,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 134,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 135,
          idTratamiento: 49,
          lstDientes: [],
        },
      ];

      this.ortodonciaNinoDientes[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 136,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 137,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 138,
          idTratamiento: 0,
          lstDientes: [],
        },
      ];
    },
    getTreatmentsIds(array) {
      const params = {
        idClinica: this.idClinica,
        lstIdsTratatamiento: array
      }
      this.$http
        .put(
          this.$api +
            "ptipresuntivo/obtener/catalogo/tratamientos/id",
          params
        )
        .then((response) => {
          // if (
          //    array.includes(6) && //guarda oclusal
          //    array.includes(120) && //retenedor placa circunferencial
          //    array.includes(127) && //retenedor placa hawley 
          //    array.includes(618) //retenedor fijo
          // ) {
          //   this.dataTreatmentsRetenedores = response.data.data.filter(
          //     function (item) {
          //       return item.nombre != "";
          //     }
          //   );
          // } 
          
          if (
            array.includes(33)  && //mantenedores de espacios
            array.includes(35) && //Arco lingual
            array.includes(629) && //Trainer for kids 
            array.includes(294) && // Arco extraoral
            array.includes(1988) && //Aparato Miofunciona
            array.includes(1989) && //Esqueleto de Sujeción de Máscara Facial con Hyrax
            array.includes(1990) && //Expansores 
            array.includes(1991)  // Banda Ansa 
          ) {
            //#RET SUP
            //#RET INF
            this.dataTreatmentsRetenedores = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
            this.dataTreatmentsRetenedoresFitro = this.dataTreatmentsRetenedores;
          } else if (array.includes(49)) {//cita de ajuste aparato de ortopedia
          //#CITA DE AJUSTE APARATO DE ORTOPEDIA
            this.dataTreatmentsCitaAjuste = response.data.data.filter(function (
              item
            ) {
              return item.nombre != "";
            });
          } else if (
            array.includes(9) && //extraccion sencilla
            array.includes(55) && //extraccion quirurgica
            array.includes(85) && //extraccion de restos radiculares sencilla 
            array.includes(86) //extraccion de restos radiculares quirurgica
          ) {
            //#EXTRACCIONES
            this.dataTreatmentsExtracciones = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
            this.dataTreatmentsExtraccionesFiltro = this.dataTreatmentsExtracciones;
          } else if (array.includes(255)) {//aditamento de semiprecisión
          //#MINI IMPLANTES
            this.dataTreatmentsMiniImplantes = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
            this.dataTreatmentsMiniImplantesFiltro = this.dataTreatmentsMiniImplantes;
          } else if (array.includes(621)) {//tope de resina (pieza)
           //#TOPES DE RESINA
            this.dataTreatmentsTopesResina = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
            this.dataTreatmentsTopesResinaFitro = this.dataTreatmentsTopesResina;
          } else if (array.includes(410)) {//cirugia para traccion de caninos
          //#TRACCIÓN DE CANINOS
            this.dataTreatmentsTraccionCaninos = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
            this.dataTreatmentsTraccionCaninosFiltro = this.dataTreatmentsTraccionCaninos;
          }
          this.$forceUpdate();
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener los tratamientos por id",
          });
          console.error(error);
        });
    },
    getTreatmentsSpeciality(array) {
      //condicional para tratamientos ORTODONCIA / ODONTOPEDIATRIA ||
      if (array.includes(3) && array.includes(4)) {
        const params = {
          idClinica: this.idClinica,
          lstIdsEspecialidad: array
        }
        this.$http
          .put(
            this.$api +
              "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidadorigen",
              params
          )
          .then((response) => {
            this.dataTreatmentsOrtoOdonto = response.data.data.filter(function (
              item
            ) {
              return item.nombre != "";
            });
            this.$forceUpdate();
            this.dataTreatmentsOrtoOdontoFiltro =  this.dataTreatmentsOrtoOdonto;
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener los tratamientos por especialidad",
            });
            console.error(error);
          });
      } else if (array.includes(4)) {
        const params = {
          idClinica: this.idClinica,
          lstIdsEspecialidad: array
        }
        this.$http
          .put(
            this.$api +
              "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidadorigen",
            params
          )
          .then((response) => {
            this.dataTreatmentsOrto = response.data.data.filter(function (
              item
            ) {
              return item.nombre != "";
            });
            this.dataTreatmentsOrtoFiltro = this.dataTreatmentsOrto;
            this.$forceUpdate();
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener los tratamientos por especialidad",
            });
            console.error(error);
          });
      }
    },
    getInfo() {
      const params = {
        idPti: this.$route.params.id
      }
      this.$http
        .post(
          this.$api +
            "ptipresuntivo/obtener/datosGenerales/noSdi", params )
        .then((response) => {
          let datos = response.data.data;
          this.fechaAltaUtc = datos.fechaAlta;

          let fecha = moment(String(datos.fechaAlta), "YYYY/MM/DD").format(
            "YYYY-MM-DD"
          );

          if (Array.isArray(datos.lstRutaTratamientoEspecialidad)) {
            datos.lstRutaTratamientoEspecialidad.forEach((element, index) => {
              element["idFront"] = index;
            });
          }

          this.DiagnosticData = {
            bruxismo: datos.bruxismo,
            placaSarro: datos.placaSarro,
            candidatoOrtodoncia:
              datos.candidatoOrtodoncia == null
                ? false
                : datos.candidatoOrtodoncia,
            enfermedadSistemica:
              datos.enfermedadSistemica == null
                ? ""
                : datos.enfermedadSistemica,
            denticion: datos.denticion == 0 ? 3 : datos.denticion, // ! Si non trae denticion pone default adulto
            edadPaciente: datos.edadPaciente,
            fechaAlta: fecha,
            folio: datos.folio,
            idClinica: datos.idClinica,
            idCompania: datos.idCompania,
            idEmpleado: datos.idEmpleado == null ? 1 : datos.idEmpleado,
            idMordida: datos.idMordida,
            idNivelPti: datos.idNivelPti,
            idPaciente: datos.idPaciente,
            idPti: datos.idPti,
            idRiesgoMonto: datos.idRiesgoMonto,
            idRiesgoTratamiento: datos.idRiesgoTratamiento,
            idUsuarioLogueado:
              datos.idUsuarioLogueado == null ? 1 : datos.idUsuarioLogueado,
            intIdEstatusPTI: 1,
            ipbI1: datos.ipbI1,
            ipbI2: datos.ipbI2,
            ipbS1: datos.ipbS1,
            ipbS2: datos.ipbS2,
            listaDientes: datos.listaDientes,
            listaDientesRegistrados: datos.listaDientes,
            lstRutaTratamientoEspecialidad:
              datos.lstRutaTratamientoEspecialidad == null
                ? []
                : datos.lstRutaTratamientoEspecialidad,
            nombreDoctor: datos.nombreDoctor,
            nombrePaciente: datos.nombrePaciente,
            observaciones:
              datos.observaciones != null ? datos.observaciones : "",
            registroActivo: datos.registroActivo,
            strNombreClinica: datos.strNombreClinica,
            observacionesDiagnostico: datos.observacionesDiagnostico,
            posibleReplica: datos.posibleReplica,
            intIdTipoSolicitudPTI: 8, //Inactiva todo este estatus
          };

          if (datos.intIdEstatusPTI != 3) {
            this.DiagnosticData.raspadoSuperior1 =
              datos.ipbS1 == 1 ? true : datos.raspadoSuperior1;
            this.DiagnosticData.raspadoSuperior2 =
              datos.ipbS2 == 1 ? true : datos.raspadoSuperior2;
            this.DiagnosticData.raspadoInferior1 =
              datos.ipbI1 == 1 ? true : datos.raspadoInferior1;
            this.DiagnosticData.raspadoInferior2 =
              datos.ipbI2 == 1 ? true : datos.raspadoInferior2;
            this.DiagnosticData.guardaOclusal = datos.bruxismo == true ? 1 : 0; // ? Guarda oclusal
            this.DiagnosticData.limpieza = datos.placaSarro == true ? 3 : 0; // ? Guarda placaSarro
          } else {
            this.DiagnosticData.raspadoSuperior1 = datos.raspadoSuperior1;
            this.DiagnosticData.raspadoSuperior2 = datos.raspadoSuperior2;
            this.DiagnosticData.raspadoInferior1 = datos.raspadoInferior1;
            this.DiagnosticData.raspadoInferior2 = datos.raspadoInferior2;
            this.DiagnosticData.guardaOclusal = datos.guardaOclusal;
            this.DiagnosticData.limpieza = datos.limpieza;
          }

          datos.listaDientes.forEach((element) => {
            if (datos.intIdEstatusPTI == 3) {

              ///aqui se llenan los datos de los tratamientos
              this.PdxSuperior.forEach((elementD) => {
                if (element.idDiente == elementD.idDiente) {

                  elementD.lstPlanTratamiento1 = element.lstPlanTratamiento1.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento1.length == 0)
                    elementD.lstPlanTratamiento1 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];

                  elementD.lstPlanTratamiento2 = element.lstPlanTratamiento2.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento2.length == 0)
                    elementD.lstPlanTratamiento2 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];

                  elementD.lstPlanTratamiento3 = element.lstPlanTratamiento3.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento3.length == 0)
                    elementD.lstPlanTratamiento3 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];
                }
              });

              this.PdxInferior.forEach((elementD) => {
                if (element.idDiente == elementD.idDiente) {
                  elementD.lstPlanTratamiento1 =
                    element.lstPlanTratamiento1.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento1.length == 0)
                    elementD.lstPlanTratamiento1 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];

                  elementD.lstPlanTratamiento2 =
                    element.lstPlanTratamiento2.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento2.length == 0)
                    elementD.lstPlanTratamiento2 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];

                  elementD.lstPlanTratamiento3 =
                    element.lstPlanTratamiento3.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento3.length == 0)
                    elementD.lstPlanTratamiento3 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];
                }
              });

              this.PdxBocaCompleta.forEach((elementD) => {
                if (element.idDiente == elementD.idDiente) {
                  elementD.lstPlanTratamiento1 =
                    element.lstPlanTratamiento1.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento1.length == 0)
                    elementD.lstPlanTratamiento1 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];

                  elementD.lstPlanTratamiento2 =
                    element.lstPlanTratamiento2.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento2.length == 0)
                    elementD.lstPlanTratamiento2 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];

                  elementD.lstPlanTratamiento3 =
                    element.lstPlanTratamiento3.filter(function (item) {
                      return item.idPadecimiento == elementD.idPadecimento;
                    });

                  if (elementD.lstPlanTratamiento3.length == 0)
                    elementD.lstPlanTratamiento3 = [
                      {
                        idTratamiento: null,
                        descripcion: null,
                        opcion: 1,
                        orden: 1,
                      },
                    ];
                }
              });
            }

            this.dientesAdulto.forEach((elementD) => {
              if (element.idDiente == elementD.idDiente) {
                elementD.lstPadecimientos = element.lstPadecimientos;
                elementD.lstPlanTratamiento1 = element.lstPlanTratamiento1;
                elementD.lstPlanTratamiento2 = element.lstPlanTratamiento2;
                elementD.lstPlanTratamiento3 = element.lstPlanTratamiento3;

                elementD.paquete1 =
                  element.lstPlanTratamiento1.length != 0
                    ? JSON.parse(JSON.stringify(element.lstPlanTratamiento1))
                    : null; // ! SOLO asi creamos una copia del array
                elementD.paquete1Lista = "  ";
                elementD.lstPlanTratamiento1.forEach((trt) => {
                  elementD.paquete1Lista += trt.nombre + ", ";
                });
                elementD.paquete1Lista = elementD.paquete1Lista.slice(0, -2);
                elementD.paquete2 =
                  element.lstPlanTratamiento2.length != 0
                    ? JSON.parse(JSON.stringify(element.lstPlanTratamiento2))
                    : null; // ! SOLO asi creamos una copia del array
                elementD.paquete2Lista = "  ";
                elementD.lstPlanTratamiento2.forEach((trt) => {
                  elementD.paquete2Lista += trt.nombre + ", ";
                });
                elementD.paquete2Lista = elementD.paquete2Lista.slice(0, -2);
                elementD.paquete3 =
                  element.lstPlanTratamiento3.length != 0
                    ? JSON.parse(JSON.stringify(element.lstPlanTratamiento3))
                    : null; // ! SOLO asi creamos una copia del array
                elementD.paquete3Lista = "  ";
                elementD.lstPlanTratamiento3.forEach((trt) => {
                  elementD.paquete3Lista += trt.nombre + ", ";
                });
                elementD.paquete3Lista = elementD.paquete3Lista.slice(0, -2);
                while (elementD.lstPadecimientos.length < 5) {
                  elementD.lstPadecimientos.push({
                    descripcion: "SIN DATO PATOLÓGICO",
                  });
                }

                while (elementD.lstPlanTratamiento1.length < 5) {
                  elementD.lstPlanTratamiento1.push({
                    idTratamiento: null,
                    descripcion: null,
                    opcion: 1,
                    orden: elementD.lstPlanTratamiento1.length + 1,
                  });
                }

                while (elementD.lstPlanTratamiento2.length < 5) {
                  elementD.lstPlanTratamiento2.push({
                    idTratamiento: null,
                    descripcion: null,
                    opcion: 2,
                    orden: elementD.lstPlanTratamiento2.length + 1,
                  });
                }

                while (elementD.lstPlanTratamiento3.length < 5) {
                  elementD.lstPlanTratamiento3.push({
                    idTratamiento: null,
                    descripcion: null,
                    opcion: 3,
                    orden: elementD.lstPlanTratamiento3.length + 1,
                  });
                }
              }
            });
            this.dientesNino.forEach((elementD) => {
              if (element.idDiente == elementD.idDiente) {
                elementD.lstPadecimientos = element.lstPadecimientos;
                elementD.lstPlanTratamiento1 = element.lstPlanTratamiento1;
                elementD.lstPlanTratamiento2 = element.lstPlanTratamiento2;
                elementD.lstPlanTratamiento3 = element.lstPlanTratamiento3;
                elementD.paquete1 =
                  element.lstPlanTratamiento1.length != 0
                    ? JSON.parse(JSON.stringify(element.lstPlanTratamiento1))
                    : []; // ! SOLO asi creamos una copia del array
                elementD.paquete1Lista = "  ";
                elementD.lstPlanTratamiento1.forEach((trt) => {
                  elementD.paquete1Lista += trt.nombre + ", ";
                });
                elementD.paquete1Lista = elementD.paquete1Lista.slice(0, -2);
                elementD.paquete2 =
                  element.lstPlanTratamiento2.length != 0
                    ? JSON.parse(JSON.stringify(element.lstPlanTratamiento2))
                    : []; // ! SOLO asi creamos una copia del array
                elementD.paquete2Lista = "";
                elementD.lstPlanTratamiento2.forEach((trt) => {
                  elementD.paquete2Lista += trt.nombre + ", ";
                });
                elementD.paquete2Lista = elementD.paquete2Lista.slice(0, -2);
                elementD.paquete3 =
                  element.lstPlanTratamiento3.length != 0
                    ? JSON.parse(JSON.stringify(element.lstPlanTratamiento3))
                    : []; // ! SOLO asi creamos una copia del array
                elementD.paquete3Lista = "";
                elementD.lstPlanTratamiento3.forEach((trt) => {
                  elementD.paquete3Lista += trt.nombre + ", ";
                });
                elementD.paquete3Lista = elementD.paquete3Lista.slice(0, -2);
                while (elementD.lstPadecimientos.length < 5) {
                  elementD.lstPadecimientos.push({
                    descripcion: "SIN DATO PATOLÓGICO",
                  });
                }

                while (elementD.lstPlanTratamiento1.length < 5) {
                  elementD.lstPlanTratamiento1.push({
                    idTratamiento: null,
                    descripcion: null,
                    opcion: 1,
                    orden: elementD.lstPlanTratamiento1.length + 1,
                  });
                }

                while (elementD.lstPlanTratamiento2.length < 5) {
                  elementD.lstPlanTratamiento2.push({
                    idTratamiento: null,
                    descripcion: null,
                    opcion: 2,
                    orden: elementD.lstPlanTratamiento2.length + 1,
                  });
                }

                while (elementD.lstPlanTratamiento3.length < 5) {
                  elementD.lstPlanTratamiento3.push({
                    idTratamiento: null,
                    descripcion: null,
                    opcion: 3,
                    orden: elementD.lstPlanTratamiento3.length + 1,
                  });
                }
              }
            });
          });

          this.optionsPlaca.forEach((element) => {
            if (
              (this.DiagnosticData.denticion == 1 &&
                element.text == "Limpieza con barniz de flúor") ||
              element.text == "Eliminación de sarro e higiene de encías"
            ) {
              element.disabled = false;
            } else if (
              (this.DiagnosticData.denticion == 2 &&
                element.text == "Limpieza") ||
              element.text == "Eliminación de sarro e higiene de encías"
            ) {
              element.disabled = false;
            } else if (this.DiagnosticData.denticion == 3) {
              element.disabled = false;
            }
          });
          this.sendTreatment();

          this.$forceUpdate();
        })
        .catch((error) => {
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "El PTI no es valido",
          });
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.idClinica = this.DiagnosticData.idClinica;

          this.getTreatments();

          this.getTreatmentsSpeciality([3, 4]); // ! ODONTOPEDIATRIA, ORTODONCIA
          this.getTreatmentsSpeciality([4]); // ! ORTODONCIA
          // ? POR ID
          // this.getTreatmentsIds([6, 120, 127, 618]); // ! RETENEDORES
          this.getTreatmentsIds([33, 1991, 1990, 1988, 1989, 35,294,629 ]); // ! RETENEDORES //#RET SUP  //#RET INF
          this.getTreatmentsIds([49]); // ! CITA DE AJUSTE
          // ? SEGUNDA SECCION
          this.getTreatmentsIds([9, 55, 85, 86]); // ! EXTRACCIONES
          this.getTreatmentsIds([255]); // ! MINI IMPLANTES
          this.getTreatmentsIds([621]); // ! TOPES DE RESINA
          this.getTreatmentsIds([410]); // ! TRACCIÓN DE CANINOS
        });
    },
    getTreatments() {
      const parametros = {idClinica: this.idClinica}
      var url = "ptipresuntivo/obtener/tratamientos/denticion"

      this.$http
          .post(this.$api + url, parametros)
          .then((response) => {
            this.dataTreatments = response.data.data.filter(function (item) {
              return item.nombre !== "";
            });

            this.dataTreatments = _.orderBy(
                this.dataTreatments,
                ["nombre"],
                ["asc"]
            );
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener los tratamientos",
            });
            console.error(error);
          })
          .finally(() => {
            this.dataTreatmentsMixto = this.dataTreatments.concat(
                this.dataTreatmentsNino
            );

            this.dataTreatmentsMixto = _.uniqBy(
                this.dataTreatmentsMixto,
                function (e) {
                  return e.idTratamiento;
                }
            );

           this.dataTreatmentsMixtoFiltro =  this.dataTreatmentsMixto;
           this.dataTreatmentsFiltro = this.dataTreatments;
          });
    },
    putNivelPti(data) {
      data.fechaAlta = this.fechaAltaUtc;
      this.$http
        .put(
          this.$api + "ptipresuntivo/calcular/nivel/pti",
          this.createArrayPeticion(data)
        )
        .then((response) => {
          this.DiagnosticData.idNivelPti = response.data.data;
        })
        .catch((error) => {
          this.DiagnosticData.idNivelPti = 0;
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al recalcular el nivel de PTI",
          });
          console.error(error);
        });
    },
    putRutaClinica(data) {
      var jsonData = JSON.parse(JSON.stringify(data)); // ! SOLO asi creamos una copia del array

      jsonData.forEach((element) => {
        element["lstPlanTratamiento1"] = element["lstPlanTratamiento1"].filter(
          function (item) {
            return item.idTratamiento != null;
          }
        );
        element["lstPlanTratamiento2"] = element["lstPlanTratamiento2"].filter(
          function (item) {
            return item.idTratamiento != null;
          }
        );
        element["lstPlanTratamiento3"] = element["lstPlanTratamiento3"].filter(
          function (item) {
            return item.idTratamiento != null;
          }
        );
      });

      const params = {
        idDenticion: this.DiagnosticData.denticion,
        listaDientes: jsonData
      }
      this.$http
        .put(
          this.$api +
            "ptipresuntivo/calcular/rutas/especialidades",
            params
        )
        .then((response) => {
          response.data.data.forEach((element) => {
            element.lngIdPti = this.DiagnosticData.idPti;
          });

          this.DiagnosticData.lstRutaTratamientoEspecialidad =
            response.data.data;

          if (
            Array.isArray(this.DiagnosticData.lstRutaTratamientoEspecialidad)
          ) {
            this.DiagnosticData.lstRutaTratamientoEspecialidad.forEach(
              (element, index) => {
                element["idFront"] = index;
              }
            );
          }
        })
        .catch((error) => {
          this.DiagnosticData.lstRutaTratamientoEspecialidad = [];
          console.error(error);
        });
    },
    getDientes(tipo) {
      var url = "ptipresuntivo/obtener/catalogo/dientes";
      const params = {
        adulto: tipo == "dientesAdulto" ? true : false, 
        ninio: tipo == "dientesAdulto" ? false : true,
      }
      this.$http
        .post(this.$api + url, params)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            const finalData = JSON.parse(JSON.stringify(response.data.data));

            if (tipo == "dientesAdulto") {
              this.dientesAdultoArray = finalData.map(function (item) {
                var data = {
                  numeroDiente: item.numeroDiente,
                  idDiente: item.idDiente,
                };
                return data;
              });
              this.dientesAdultoArrayFiltro = this.dientesAdultoArray;

            } else {
              this.dientesNinoArray = finalData.map(function (item) {
                var data = {
                  numeroDiente: item.numeroDiente,
                  idDiente: item.idDiente,
                };
                return data;
              });
            }

            finalData.forEach((element) => {
              if (element.numeroDiente != null) {
                this[tipo].push({
                  idDiente: element.idDiente,
                  nombreDiente: element.nombre,
                  numeroDiente: element.numeroDiente,
                  ninoAdulto: element.ninoAdulto,
                  lstPadecimientos: [
                    {
                      idPadecimento: 0,
                      descripcion: "SIN DATO PATOLÓGICO",
                    },
                    {
                      idPadecimento: 0,
                      descripcion: "SIN DATO PATOLÓGICO",
                    },
                    {
                      idPadecimento: 0,
                      descripcion: "SIN DATO PATOLÓGICO",
                    },
                    {
                      idPadecimento: 0,
                      descripcion: "SIN DATO PATOLÓGICO",
                    },
                    {
                      idPadecimento: 0,
                      descripcion: "SIN DATO PATOLÓGICO",
                    },
                  ],
                  lstPlanTratamiento1: [
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 1,
                      orden: 1,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 1,
                      orden: 2,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 1,
                      orden: 3,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 1,
                      orden: 4,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 1,
                      orden: 5,
                    },
                  ],
                  lstPlanTratamiento2: [
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 2,
                      orden: 1,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 2,
                      orden: 2,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 2,
                      orden: 3,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 2,
                      orden: 4,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 2,
                      orden: 5,
                    },
                  ],
                  lstPlanTratamiento3: [
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 3,
                      orden: 1,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 3,
                      orden: 2,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 3,
                      orden: 3,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 3,
                      orden: 4,
                    },
                    {
                      idTratamiento: null,
                      descripcion: null,
                      opcion: 3,
                      orden: 5,
                    },
                  ],
                });
              }
            });
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener los dientes",
          });
          console.error(error);
        })
        .finally(() => {
          if (tipo == "dientesAdulto") {
            this.loadingDientesAdulto = false;
          } else {
            this.loadingDientesNino = false;
          }

          if (!this.loadingDientesAdulto && !this.loadingDientesNino) {
            this.getInfo();
          }
        });
    },
    sendTreatment() {
      this.dataSendTrts = this.PdxSuperior.concat(
        this.PdxInferior,
        this.PdxBocaCompleta
      );

      this.setDientes("dientesNino");
      this.setDientes("dientesAdulto");

      this.dataSendTrts = this.dataSendTrts.concat(this.trtsCasosEsp);


      this.DiagnosticData["listaDientes"] = this.dataSendTrts;

      this.putNivelPti(this.DiagnosticData);
      this.putRutaClinica(this.dataSendTrts);
    },
    getImgUrl(pic) {
      return require("../assets/" + pic);
    },
    sendData() {
      var formularidoValidadoNino = false;

      if(this.DiagnosticData.denticion === 1 || this.DiagnosticData.denticion === 3){
        this.ortodonciaNino['tratamientos1'].map(item =>{
          if(item.cantidad >= 1 && (item.idTratamiento === null || item.idTratamiento ===0) && !formularidoValidadoNino){
            formularidoValidadoNino = true;
          }
        });
      }


      if(formularidoValidadoNino === true){
        this.$swal.fire({
          icon: "info",
          title: "Se debe seleccionar un tratamiento en Plan de Ortopedia Niño.",
        });
        return false;
      }

      var formularidoValidadoAdulto = false;

      if (this.DiagnosticData.denticion === 2 || this.DiagnosticData.denticion === 3){
        this.ortodonciaAdulto['tratamientos1'].map(item =>{
          if(item.cantidad >= 1 && (item.idTratamiento === null || item.idTratamiento ===0) && !formularidoValidadoAdulto){
            formularidoValidadoAdulto = true;
          }
        });
      }

      if(formularidoValidadoAdulto === true){
        this.$swal.fire({
          icon: "info",
          title: "Se debe seleccionar un tratamiento en Plan de Ortodoncia Adulto.",
        });
        return false;
      }

      /* SECCION SUPERNUMERARIOS */
      var superNumerarios = [];
      var superNumerarioEnvio = {
        idDiente: 73,
        ninoAdulto: undefined,
        nombreDiente: undefined,
        numeroDiente: 0,
        lstPadecimientos: [{ idPadecimento: 0, validacion: false }],
        lstPlanTratamiento1: [],
        lstPlanTratamiento2: [],
        lstPlanTratamiento3: [],
      };

      this.dataSendTrts = this.PdxSuperior.concat(
        this.PdxInferior,
        this.PdxBocaCompleta
      );

      this.setDientes("dientesNino");
      this.setDientes("dientesAdulto");

      this.dataSendTrts = this.dataSendTrts.concat(this.trtsCasosEsp);
      this.DiagnosticData["listaDientes"] = this.dataSendTrts;

      superNumerarios = _.filter(
        this.DiagnosticData["listaDientes"],
        function (o) {
          return o.idDiente == 73;
        }
      );
      this.DiagnosticData["listaDientes"] = _.remove(
        this.DiagnosticData["listaDientes"],
        function (n) {
          return n.idDiente != 73;
        }
      );

      if (superNumerarios.length != 0) {
        this.DiagnosticData["listaDientes"].push(superNumerarioEnvio);
        superNumerarios.forEach((itm) => {
          if (itm.lstPadecimientos.length != 0) {
            itm.lstPadecimientos.forEach((pdx) => {
              if (pdx.idPtiPadecimento !== undefined) {
                superNumerarioEnvio.lstPadecimientos.push(pdx);
              }
            });
          }

          if (itm.lstPlanTratamiento1.length != 0) {
            itm.lstPlanTratamiento1.forEach((trt) => {
              if (trt.idTratamiento != null) {
                superNumerarioEnvio.lstPlanTratamiento1.push(trt);
              }
            });
          }

          if (itm.lstPlanTratamiento2.length != 0) {
            itm.lstPlanTratamiento2.forEach((trt) => {
              if (trt.idTratamiento != null) {
                superNumerarioEnvio.lstPlanTratamiento2.push(trt);
              }
            });
          }

          if (itm.lstPlanTratamiento3.length != 0) {
            itm.lstPlanTratamiento3.forEach((trt) => {
              if (trt.idTratamiento != null) {
                superNumerarioEnvio.lstPlanTratamiento3.push(trt);
              }
            });
          }
        });
      }

      superNumerarioEnvio.lstPadecimientos = _.uniqBy(
        superNumerarioEnvio.lstPadecimientos,
        (obj) => obj.idPtiPadecimento
      );

      superNumerarioEnvio.lstPlanTratamiento1 = _.uniqBy(
        superNumerarioEnvio.lstPlanTratamiento1,
        (obj) => obj.idTratamiento
      );
      superNumerarioEnvio.lstPlanTratamiento2 = _.uniqBy(
        superNumerarioEnvio.lstPlanTratamiento2,
        (obj) => obj.idTratamiento
      );
      superNumerarioEnvio.lstPlanTratamiento3 = _.uniqBy(
        superNumerarioEnvio.lstPlanTratamiento3,
        (obj) => obj.idTratamiento
      );
      /* SECCION SUPERNUMERARIOS */
      var bandera = false;

      this.DiagnosticData["listaDientes"].forEach((element) => {
        var checkColumnUno = false;
        var checkColumnDos = false;
        var checkColumnTres = false;
        var banderavalidacion = element.lstPadecimientos[0].validacion
          ? element.lstPadecimientos[0].validacion
          : false;

        if (banderavalidacion) {
          element.lstPlanTratamiento1.forEach((elementUno) => {
            if (elementUno.idTratamiento != null) {
              checkColumnUno = true;
            }
          });

          element.lstPlanTratamiento2.forEach((elementUno) => {
            if (elementUno.idTratamiento != null) {
              checkColumnDos = true;
            }
          });

          element.lstPlanTratamiento3.forEach((elementUno) => {
            if (elementUno.idTratamiento != null) {
              checkColumnTres = true;
            }
          });
          if (
            checkColumnUno == false &&
            checkColumnDos == false &&
            checkColumnTres == false
          ) {
            var txt =
              element.numeroDiente == 0
                ? "SUPERNUMERARIO"
                : element.numeroDiente;
            this.$swal.fire({
              icon: "info",
              title: "Falta agregar tratamientos",
              text: "El diente " + txt + " No cuenta con 1 tx.",
            });
            bandera = true;
          }
        }
      });

      // ? BANDERA ORTODONCIA
      var banderaOrtodoncia = false;

      if (this.DiagnosticData.candidatoOrtodoncia == true) {
        var OrtodonciaCheckUno = false;
        var OrtodonciaCheckDos = false;
        var OrtodonciaCheckTres = false;

        var datos = {
          tratamientos1: this.ortodonciaAdulto["tratamientos1"].concat(
            this.ortodonciaAdultoDientes["tratamientos1"],
            this.ortodonciaNino["tratamientos1"],
            this.ortodonciaNinoDientes["tratamientos1"]
          ),
          tratamientos2: this.ortodonciaAdulto["tratamientos2"].concat(
            this.ortodonciaAdultoDientes["tratamientos2"],
            this.ortodonciaNino["tratamientos2"],
            this.ortodonciaNinoDientes["tratamientos2"]
          ),
          tratamientos3: this.ortodonciaAdulto["tratamientos3"].concat(
            this.ortodonciaAdultoDientes["tratamientos3"],
            this.ortodonciaNino["tratamientos3"],
            this.ortodonciaNinoDientes["tratamientos3"]
          ),
        };

        //BANDERA VALIDACION
        if (Array.isArray(datos.tratamientos1)) {
          datos.tratamientos1.forEach((item) => {
            if (
              item.idTratamiento != 49 &&
              item.idTratamiento != 0 &&
              (item.lstDientes == undefined ||
                item.lstDientes == null ||
                item.lstDientes.length == 0)
            ) {
              if (item.cantidad == 0 || item.idDienteArcoBoca == 0) {
                OrtodonciaCheckUno = true;
                if( item.cantidad == 0 && (item.idDienteArcoBoca == 0 && item.idTratamiento == null) ) {
                  OrtodonciaCheckUno = false;
                }
              }
            } else if (
              item.lstDientes != undefined &&
              item.lstDientes != null &&
              item.lstDientes.length != 0
            ) {
              if (item.idTratamiento == 0) {
                OrtodonciaCheckUno = true;
              }
            }
          });
        }

        if (Array.isArray(datos.tratamientos2)) {
          datos.tratamientos2.forEach((item) => {
            if (
              item.idTratamiento != 49 &&
              item.idTratamiento != 0 &&
              (item.lstDientes == undefined ||
                item.lstDientes == null ||
                item.lstDientes.length == 0)
            ) {
              if (item.cantidad == 0 || item.idDienteArcoBoca == 0) {
                OrtodonciaCheckDos = true;
              }
            } else if (
              item.lstDientes != undefined &&
              item.lstDientes != null &&
              item.lstDientes.length != 0
            ) {
              if (item.idTratamiento == 0) {
                OrtodonciaCheckDos = true;
              }
            }
          });
        }

        if (Array.isArray(datos.tratamientos3)) {
          datos.tratamientos3.forEach((item) => {
            if (
              item.idTratamiento != 49 &&
              item.idTratamiento != 0 &&
              (item.lstDientes == undefined ||
                item.lstDientes == null ||
                item.lstDientes.length == 0)
            ) {
              if (item.cantidad == 0 || item.idDienteArcoBoca == 0) {
                OrtodonciaCheckTres = true;
              }
            } else if (
              item.lstDientes != undefined &&
              item.lstDientes != null &&
              item.lstDientes.length != 0
            ) {
              if (item.idTratamiento == 0) {
                OrtodonciaCheckTres = true;
              }
            }
          });
        }

        if (
          OrtodonciaCheckUno == true ||
          OrtodonciaCheckDos == true ||
          OrtodonciaCheckTres == true
        ) {
          this.$swal.fire({
            icon: "info",
            title: "Faltan datos",
            text: "Falta llenar todos los campos en la sección de ortodoncia.",
          });
          banderaOrtodoncia = true;
        }
      }
      // ? BANDERA ORTODONCIA
      if (bandera == false && banderaOrtodoncia == false) {
        this.$swal.fire({
          title: "¿Estás seguro de enviar el PTI?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.banderaBtn = true;
            this.loading = true;
            this.$http
              .put(
                this.$api + "ptipresuntivo/guardar/datosGenerales/noSdi",
                this.createArrayPeticion(this.DiagnosticData)
              )
              .then(() => {
                if (this.DiagnosticData.candidatoOrtodoncia == true) {
                  this.saveOrtodoncia();
                }
              })
              .catch((error) => {
                this.banderaBtn = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.response.data.message,
                });
              })
              .finally(() => {
                this.loading = false;
                this.$swal({
                  icon: "success",
                  title: "Se ingresó correctamente",
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {},
                });
                /*if (this.DiagnosticData.candidatoOrtodoncia != true) {
                  location.reload();
                }*/
              });
          },
        });
      }
    },
    setDientes(array) {
      this[array].forEach((element) => {
        var boolean1 = false;
        var boolean2 = false;
        var boolean3 = false;

        var booleanPadecimiento = false;
        element.lstPlanTratamiento1.forEach((elementUno) => {
          if (elementUno.idTratamiento != null) {
            boolean1 = true;
          }
        });

        element.lstPlanTratamiento2.forEach((elementDos) => {
          if (elementDos.idTratamiento != null) {
            boolean2 = true;
          }
        });

        element.lstPlanTratamiento3.forEach((elementTres) => {
          if (elementTres.idTratamiento != null) {
            boolean3 = true;
          }
        });

        element.lstPadecimientos.forEach((elementCuatro) => {
          if (elementCuatro.idPadecimento != 0) {
            booleanPadecimiento = true;
          }
        });

        if (
          boolean1 == true ||
          boolean2 == true ||
          boolean3 == true ||
          booleanPadecimiento == true
        ) {

          const existePadSuperior = this.PdxBocaCompleta.some(it=>it.idDiente == element.idDiente
              && it.lstPadecimientos[0].idPadecimento == element.lstPadecimientos[0].idPadecimento);

          const existePadInferior = this.PdxBocaCompleta.some(it=>it.idDiente == element.idDiente
              && it.lstPadecimientos[0].idPadecimento == element.lstPadecimientos[0].idPadecimento);

          const existePadecimientoEnBocaCompleta = this.PdxBocaCompleta.some(it=>it.idDiente == element.idDiente
                                  && it.lstPadecimientos[0].idPadecimento == element.lstPadecimientos[0].idPadecimento);

          if (existePadSuperior || existePadInferior || existePadecimientoEnBocaCompleta) {
            const idxPadecimientoEnListaDiente = this.dataSendTrts.findIndex(it => it.idDiente == element.idDiente
                && it.lstPadecimientos[0].idPadecimento == element.lstPadecimientos[0].idPadecimento)

            if (idxPadecimientoEnListaDiente !== undefined && idxPadecimientoEnListaDiente > 0) {
              this.dataSendTrts.splice(idxPadecimientoEnListaDiente, 1);
            }
          }

          this.dataSendTrts.push(element);

        }

      });
    },
    move(from, to) {
      this.DiagnosticData.lstRutaTratamientoEspecialidad.move(from, to);
      this.DiagnosticData.lstRutaTratamientoEspecialidad.forEach(
        (element, index) => {
          this.$set(
            this.DiagnosticData.lstRutaTratamientoEspecialidad[index],
            index,
            {
              intgerOrden: (index += 1),
            }
          ); // ! FORZAR RE RENDERIZADO
        }
      );

      this.DiagnosticData.lstRutaTratamientoEspecialidad.forEach(
        (element, index) => {
          element.intgerOrden = index += 1;
        }
      );
    },
    cleanList(tx, array) {
      var planTxt = null;
      switch (tx) {
        case "lstPlanTratamiento1":
          planTxt = "PTI Presuntivo I";
          break;
        case "lstPlanTratamiento2":
          planTxt = "PTI Presuntivo II";

          break;
        case "lstPlanTratamiento3":
          planTxt = "PTI Presuntivo III";
          break;
        default:
          break;
      }
      this.$swal.fire({
        title: "¿Estás seguro limpiar el " + planTxt + "?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this[array].forEach((element) => {
            element[tx].forEach((element) => {
              element.idTratamiento = null;
              element.descripcion = null;
            });
            this.$forceUpdate();
          });
          // ACTUALIZANDO NIVEL DE PTI Y RUTA CLINICA
          this.sendTreatment();
          // ACTUALIZANDO NIVEL DE PTI Y RUTA CLINICA
        },
      });
    },
    addTreatment: function (numeroDiente, tx, array, opcion) {
      this[array].forEach((element) => {
        if (element.numeroDiente == numeroDiente) {
          element[tx].push({
            idTratamiento: null,
            descripcion: null,
            opcion: opcion,
            orden: element[tx].length + 1,
          });
        }
        this.$forceUpdate();
      });
    },
    addPaquete(numeroDiente, listaPlan, arrayTrts, array) {
      var arregloTrts = JSON.parse(JSON.stringify(arrayTrts));
      if (arrayTrts != undefined && arrayTrts.length != 0) {
        this[array].forEach((element) => {
          if (element.numeroDiente == numeroDiente) {
            element[listaPlan] = arregloTrts;
            while (element[listaPlan].length < 5) {
              element[listaPlan].push({
                idTratamiento: null,
                descripcion: null,
                opcion: 1,
                orden: element[listaPlan].length + 1,
              });
            }
          }
          this.$forceUpdate();
        });
      }
      // ACTUALIZANDO NIVEL DE PTI Y RUTA CLINICA
      this.sendTreatment();
      // ACTUALIZANDO NIVEL DE PTI Y RUTA CLINICA
    },
    limpiarDatosDiente(numeroDiente, listaPlan, array) {
      this[array].forEach((element) => {
        if (element.numeroDiente == numeroDiente) {
          element[listaPlan] = [];
          while (element[listaPlan].length < 5) {
            element[listaPlan].push({
              idTratamiento: null,
              descripcion: null,
              opcion: 1,
              orden: element[listaPlan].length + 1,
            });
          }
        }
        this.$forceUpdate();
      });
      this.sendTreatment();
    },
    createArrayPeticion(datos) {
      const datosPeticion = JSON.parse(JSON.stringify(datos));
      const objeto = {
        bruxismo: datosPeticion.bruxismo,
        candidatoOrtodoncia: datosPeticion.candidatoOrtodoncia,
        denticion: datosPeticion.denticion,
        edadPaciente: datosPeticion.edadPaciente,
        enfermedadSistemica: datosPeticion.enfermedadSistemica,
        guardaOclusal: datosPeticion.guardaOclusal,
        idClinica: datosPeticion.idClinica,
        idCompania: datosPeticion.idCompania,
        idEmpleado: datosPeticion.idEmpleado,
        idMordida: datosPeticion.idMordida,
        idNivelPti: datosPeticion.idNivelPti,
        idPaciente: datosPeticion.idPaciente,
        idPti: datosPeticion.idPti,
        idRiesgoMonto: datosPeticion.idRiesgoMonto,
        idRiesgoTratamiento: datosPeticion.idRiesgoTratamiento,
        idUsuarioLogueado: datosPeticion.idUsuarioLogueado,
        intIdEstatusPTI: datosPeticion.intIdEstatusPTI,
        intIdTipoSolicitudPTI: datosPeticion.intIdTipoSolicitudPTI,
        ipbI1: datosPeticion.ipbI1,
        ipbI2: datosPeticion.ipbI2,
        ipbS1: datosPeticion.ipbS1,
        ipbS2: datosPeticion.ipbS2,
        limpieza: datosPeticion.limpieza,
        observaciones: datosPeticion.observaciones,
        observacionesDiagnostico: datosPeticion.observacionesDiagnostico,
        placaSarro: datosPeticion.placaSarro,
        posibleReplica: datosPeticion.posibleReplica,
        raspadoInferior1: datosPeticion.raspadoInferior1,
        raspadoInferior2: datosPeticion.raspadoInferior2,
        raspadoSuperior1: datosPeticion.raspadoSuperior1,
        raspadoSuperior2: datosPeticion.raspadoSuperior2,
        listaDientes: Array,
        lstRutaTratamientoEspecialidad: Array,
      };

      objeto.listaDientes = datosPeticion.listaDientes
        .map((element) => {
          //delete element.lstPadecimientos
          delete element.nombreDiente;

          delete element.paquete1;
          delete element.paquete1Lista;

          delete element.paquete2;
          delete element.paquete2Lista;

          delete element.paquete3;
          delete element.paquete3Lista;

          delete element.numeroDiente;

          element.lstPlanTratamiento1 = element.lstPlanTratamiento1
            .filter((itemUno) => itemUno.idTratamiento !== null)
            .map((item) => {
              const trt = {
                idTratamiento: item.idTratamiento,
                opcion: item.opcion,
                orden: item.orden,
                idEspecialidad: item.idEspecialidad,
              };
              return trt;
            });

          element.lstPlanTratamiento2 = element.lstPlanTratamiento2
            .filter((itemUno) => itemUno.idTratamiento !== null)
            .map((item) => {
              const trt = {
                idTratamiento: item.idTratamiento,
                opcion: item.opcion,
                orden: item.orden,
                idEspecialidad: item.idEspecialidad,
              };
              return trt;
            });

          element.lstPlanTratamiento3 = element.lstPlanTratamiento3
            .filter((itemUno) => itemUno.idTratamiento !== null)
            .map((item) => {
              const trt = {
                idTratamiento: item.idTratamiento,
                opcion: item.opcion,
                orden: item.orden,
                idEspecialidad: item.idEspecialidad,
              };
              return trt;
            });
          return element;
        })
        .filter(
          (item) =>
            item.lstPlanTratamiento1.length > 0 ||
            item.lstPlanTratamiento2.length > 0 ||
            item.lstPlanTratamiento3.length > 0
        );

      objeto.lstRutaTratamientoEspecialidad =
        datosPeticion.lstRutaTratamientoEspecialidad
          .filter((itm) => itm.intgerOrden != null)
          .map((element) => {
            const datos = {
              idEspecialidad1: element.idEspecialidad1,
              idEspecialidad2: element.idEspecialidad2,
              idEspecialidad3: element.idEspecialidad3,
              intgerOrden: element.intgerOrden,
              lngIdPti: element.lngIdPti,
            };
            return datos;
          });
      return objeto;
    },
    check() {
      // !CHECAR CUANDO TENGA PROBLEMAS AL REFRESCAR UN CHECKBOX
      this.$nextTick(() => {
        this.obtenerTratamientosIds();
        this.$forceUpdate();
      });
    },
    eliminarTerapia() {
      this.trtsCasosEsp = _.filter(this.trtsCasosEsp, function (item) {
        return item.idTratamiento != 144 && item.idDiente != 59;
      });
    },
    eliminarTratamiento(idTratamiento, idDiente) {
      for (var i = 0; i < this.trtsCasosEsp.length; i++) {
        if (
          this.trtsCasosEsp[i]["idTratamiento"] === idTratamiento &&
          this.trtsCasosEsp[i]["idDiente"] === idDiente
        ) {
          this.trtsCasosEsp.splice(i, 1);
        }
      }
    },
    obtenerTratamientosIds() {
      if (this.DiagnosticData.raspadoSuperior1) {
        // ? se asigna tratamiento
        this.AsignacionTratamientos(116, 66, 72); // ? Raspado y Alisado Radiculares cerrados superiores (Cuadrente I)
        this.AsignacionTratamientos(144, 59, 71); //? Terapia de Mantenimiento periodontal (BOCA COMPLETA)
        this.terapia = true;
      } else {
        this.eliminarTratamiento(116, 66);
      }

      if (this.DiagnosticData.raspadoSuperior2) {
        // ? se asigna tratamiento
        this.AsignacionTratamientos(116, 69, 72); // ? Raspado y Alisado Radiculares cerrados superiores (Cuadrente II)
        this.AsignacionTratamientos(144, 59, 71); //? Terapia de Mantenimiento periodontal (BOCA COMPLETA)
        this.terapia = true;
      } else {
        this.eliminarTratamiento(116, 69);
      }

      if (this.DiagnosticData.raspadoInferior1) {
        // ? se asigna tratamiento
        this.AsignacionTratamientos(116, 70, 72); // ? Raspado y Alisado Radiculares cerrados Inferiores (Cuadrente IV)
        this.AsignacionTratamientos(144, 59, 71); //? Terapia de Mantenimiento periodontal (BOCA COMPLETA)
        this.terapia = true;
      } else {
        this.eliminarTratamiento(116, 70);
      }

      if (this.DiagnosticData.raspadoInferior2) {
        // ? se asigna tratamiento
        this.AsignacionTratamientos(116, 71, 72); // ? Raspado y Alisado Radiculares cerrados Inferiores (Cuadrente IV)
        this.AsignacionTratamientos(144, 59, 71); //? Terapia de Mantenimiento periodontal (BOCA COMPLETA)
        this.terapia = true;
      } else {
        this.eliminarTratamiento(116, 71);
      }

      if (
        !this.DiagnosticData.raspadoSuperior1 &&
        !this.DiagnosticData.raspadoSuperior2 &&
        !this.DiagnosticData.raspadoInferior1 &&
        !this.DiagnosticData.raspadoInferior2
      ) {
        this.eliminarTerapia();
        this.terapia = false;
      }
      this.sendTreatment();
    },
    AsignacionTrtsRuta(idTratamiento, arcadaBoca, idPadecimento) {
      this.PdxSuperior.forEach((itm) => {
        if (itm.idPadecimento == idPadecimento && itm.idDiente == arcadaBoca
            && (itm.lstPlanTratamiento1[0]["idTratamiento"] === undefined || itm.lstPlanTratamiento1[0]["idTratamiento"] === null)) {
          itm.lstPlanTratamiento1[0]["idTratamiento"] = idTratamiento;
          itm.lstPlanTratamiento2[0]["idTratamiento"] = idTratamiento;
          itm.lstPlanTratamiento3[0]["idTratamiento"] = idTratamiento;
        }
      });

      this.PdxInferior.forEach((itm) => {
        if (itm.idPadecimento == idPadecimento && itm.idDiente == arcadaBoca
            && (itm.lstPlanTratamiento1[0]["idTratamiento"] === undefined || itm.lstPlanTratamiento1[0]["idTratamiento"] === null)) {
          itm.lstPlanTratamiento1[0]["idTratamiento"] = idTratamiento;
          itm.lstPlanTratamiento2[0]["idTratamiento"] = idTratamiento;
          itm.lstPlanTratamiento3[0]["idTratamiento"] = idTratamiento;
        }
      });

      this.PdxBocaCompleta.forEach((itm) => {
        if (itm.idPadecimento == idPadecimento && itm.idDiente == arcadaBoca
            && (itm.lstPlanTratamiento1[0]["idTratamiento"] === undefined || itm.lstPlanTratamiento1[0]["idTratamiento"] === null)) {
          itm.lstPlanTratamiento1[0]["idTratamiento"] = idTratamiento;
          itm.lstPlanTratamiento2[0]["idTratamiento"] = idTratamiento;
          itm.lstPlanTratamiento3[0]["idTratamiento"] = idTratamiento;
        }
      });
    },
    generarRutaNivel() {
      if (this.DiagnosticData.limpieza != 0) {
        // ? se asigna tratamiento
        switch (this.DiagnosticData.limpieza) {
          case 1:
            this.AsignacionTrtsRuta(4, 59, 74); // ?limpieza (BOCA COMPLETA)
            break;
          case 2:
            this.AsignacionTrtsRuta(461, 59, 74); // ?limpieza  con barniz de fluor (BOCA COMPLETA)
            break;
          case 3:
            this.AsignacionTrtsRuta(912, 59, 74); // ?Eliminación de sarro e higiene de encías ! PENDIENTE (BOCA COMPLETA)
            break;
          default:
            break;
        }
      }

      if (this.DiagnosticData.guardaOclusal != 0) {
        // ? se asigna tratamiento

        switch (this.DiagnosticData.guardaOclusal) {
          case 1:
            this.AsignacionTrtsRuta(6, 57, 10); // ?guarda oclusal (BOCA COMPLETA)
            break;
          case 2:
            this.AsignacionTrtsRuta(181, 57, 10); // ?guarda oclusal confeccionado en laboratoriol (BOCA COMPLETA)
            break;
          default:
            break;
        }
      }

      this.sendTreatment();
    },
    constuirPdx(arcadaBoca, array, arrayNombre) {
      array.forEach((item) => {
        this[arrayNombre].push({
          idDiente: arcadaBoca,
          nombreDiente: "SIN NOMBRE",
          numeroDiente: 0,
          ninoAdulto: "ADL",
          nuevo: true,
          lstPadecimientos: [
            {
              idPadecimento: item.id,
              descripcion: item.nombre,
              validacion: false,
            },
          ],
          idPadecimento: item.id,
          lstPlanTratamiento1: [
            {
              idTratamiento: null,
              descripcion: null,
              opcion: 1,
              orden: 1,
            },
          ],
          lstPlanTratamiento2: [
            {
              idTratamiento: null,
              descripcion: null,
              opcion: 1,
              orden: 1,
            },
          ],
          lstPlanTratamiento3: [
            {
              idTratamiento: null,
              descripcion: null,
              opcion: 1,
              orden: 1,
            },
          ],
        });
      });
    },
    AsignacionTratamientos(idTratamiento, idDiente, idPadecimento) {
      var banderaAdultiNino = true;
      var bandera = this.dataSendTrts.some(
        (itm) =>
          itm.idTratamiento === idTratamiento && itm.idDiente === idDiente
      );
      if (!bandera) {
        if (this.DiagnosticData.denticion == 1) {
          if (idTratamiento == 116 || idTratamiento == 144) {
            banderaAdultiNino = false; // ! SOLO PARA ADULTO Y MIXTO SE ASIGNA LO DE RASPADOS
          }
        } else {
          banderaAdultiNino = true;
        }

        if (banderaAdultiNino) {
          this.trtsCasosEsp.push({
            idDiente: idDiente,
            nombreDiente: "SIN NOMBRE",
            numeroDiente: 0,
            ninoAdulto: "ADL",
            nuevo: true,
            lstPadecimientos: [
              {
                idPadecimento: idPadecimento,
              },
            ],
            idTratamiento: idTratamiento,
            lstPlanTratamiento1: [
              {
                idTratamiento: idTratamiento,
                descripcion: null,
                opcion: 1,
                orden: 1,
              },
            ],
            lstPlanTratamiento2: [
              {
                idTratamiento: idTratamiento,
                descripcion: null,
                opcion: 1,
                orden: 1,
              },
            ],
            lstPlanTratamiento3: [
              {
                idTratamiento: idTratamiento,
                descripcion: null,
                opcion: 1,
                orden: 1,
              },
            ],
          });
        }
        this.sendTreatment();
      }
    },
  },
  watch: {
    "DiagnosticData.raspadoSuperior1"() {
      this.obtenerTratamientosIds();
    },
    "DiagnosticData.raspadoSuperior2"() {
      this.obtenerTratamientosIds();
    },
    "DiagnosticData.raspadoInferior1"() {
      this.obtenerTratamientosIds();
    },
    "DiagnosticData.raspadoInferior2"() {
      this.obtenerTratamientosIds();
    },
    "DiagnosticData.limpieza"() {
      if (this.DiagnosticData.intIdEstatusPTI != 3) {
        this.generarRutaNivel();
      }
    },
    "DiagnosticData.guardaOclusal"() {
      if (this.DiagnosticData.intIdEstatusPTI != 3) {
        this.generarRutaNivel();
      }
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style scoped>
.btnTop {
  margin-top: 15px;
}

.padecimientoCss {
  color: #495057;
  border: 1px solid #ced4da;
  background-color: #e9ecef;
  border-radius: 3px;
  font-size: 1rem;
}

.divOrden {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.styleButtons {
  font-size: 30px;
  color: black;
  display: flex;
  flex-direction: column;
}

.iconBtn {
  border: 1px solid black;
  cursor: pointer;
}

.oddTratamiento {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 140px;
}

.flxRow {
  display: flex;
  flex-direction: row;
}

.div100 {
  width: 100%;
}

.txt20 {
  font-size: 20px !important;
  text-align: left;
}

.backgroundBlue {
  background-color: #b9cde6;
}

.width33 {
  width: 33% !important;
  max-width: 33% !important;
  min-width: 33% !important;
}

.inputWidth {
  width: 80%;
}

select {
  font-size: 10px !important;
}

.txtTitleB {
  color: white !important;
}

.colorSubtitle {
  color: white !important;
  font-weight: bold !important;
}

.btnSave {
  background-color: #0e6ba9 !important;
}

/*Pendiente*/
.flxRowTreatment {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
}

.dotRed {
  height: 15px;
  width: 15px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}

.backgroundAccent {
  background-color: #ff5252 !important;
  color: white !important;
}

.hallazgosCss {
  text-align: center;
}

.ultimaParte {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 30px;
  margin-bottom: 30px;
}

.ultimaPartePerio {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 30px;
  margin-bottom: 30px;
}

.tablaRutas {
  padding: 10px;
}

.tablesDisplayFlx {
  display: flex;
  flex-direction: row;
}

.txtTables {
  font-size: 13px;
}

.iconMove {
  cursor: pointer;
  border: 0px !important;
}

.iconBlue {
  color: #fff;
  background-color: #007bff;
}

.iconRed {
  color: white;
  background-color: red;
  margin-left: 10px;
}

.txtCitaAjuste {
  font-size: 14px;
}

.dropDownCss {
  background-color: #007bff !important;
}

.btnLimpiarDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.pdxArcada {
  text-align: left;
}

.pdxArcadaPadding {
  padding-left: 5px;
}

.colorPrincipal {
  background-color: #0e6ba9 !important;
}

.colorTxt {
  color: #0e6ba9 !important;
  font-size: 18px;
  margin-left: 5px;
}

.paddingPadecimientosTabla {
  padding-top: 45px;
  padding-bottom: 45px;
}
</style>
